import React, { useState } from "react";
import axios from "axios";
import { API_BASE } from "./api";

function UploadPage() {
  const [files, setFiles] = useState([]);
  const [uploadedBy, setUploadedBy] = useState(1);

 const handleUpload = async () => {
  const formData = new FormData();
  files.forEach(file => formData.append("photos[]", file));

  try {
    const res = await axios.post(`${API_BASE}/upload.php`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    if (res.data.success) {
      alert("Uploaded successfully");
    } else {
      console.error("Server error:", res.data);
      alert("Upload failed: " + (res.data.error || "Unknown error"));
    }
  } catch (err) {
    console.error("Upload failed:", err.response?.data || err.message);
    alert("Upload failed. Check console for details.");
  }
};


  return (
    <div>
      <h2>Upload Photos</h2>
      <input type="file" multiple onChange={e => setFiles([...e.target.files])} />
      <button onClick={handleUpload}>Upload</button>
    </div>
  );
}
export default UploadPage;